<template>
  <div class="Container">
    <h2>{{ $t('auth.forgot_password.sub_welcome') }}</h2>

    <span v-if="success">{{ $t('auth.forgot_password.success') }}</span>

    <form submit.prevent="resetPassword">
      <vv-form-text-input
        label="username"
        id="username"
        v-model="username"
        :validate="'required|email'"
      />

      <validate-form-button
        @click="resetPassword"
        :label="'forms.resetPasswordCta'"
        :isLoading="isLoading"
      />
    </form>
  </div>
</template>

<script>
import { RESET_PASSWORD } from '@/store/modules/user/types'
import ValidateFormButton from '@/components/common/ValidateFormButton'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import { SNACKBAR_MESSAGE } from '@/helpers/eventBus'

export default {
  name: 'ResetPassword',
  components: {
    VvFormTextInput,
    ValidateFormButton
  },
  data: () => ({
    username: '',
    isLoading: false,
    success: false
  }),
  methods: {
    async resetPassword() {
      this.$validator.validateAll().then(async result => {
        if (!result) {
          return
        }

        this.isLoading = true

        const [error, response] = await this.$store.dispatch(RESET_PASSWORD, this.username)

        if (error || response.data.error) {
          if (error && error.code) {
            this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + error.code)})
          } else {
            if (response.data.code) {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.' + response.data.code)})
            } else {
              this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('errors.custom/internal-error')})
            }
          }

          this.isLoading = false
        } else {
          this.success = true
          this.$eventBus.$emit(SNACKBAR_MESSAGE, { message: this.$t('success.forgotPasswordEmailReceived')})
        }

        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.Container {
  display: block;
  margin-left: 25px;
  width: calc(100% - 50px);
  margin-right: 25px;
}
</style>
